export function datetimeFormatter(val: string): string {
  return String(
    new Date(val).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    })
  );
}
